var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"ui-switch",class:{
        'ui-switch--checked': _vm.isChecked,
        'ui-switch--disabled': _vm.disabled,
    }},[_c('input',{staticClass:"ui-switch__input",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.isChecked},on:{"change":_vm.onChange}}),_vm._m(0),(_vm.label)?_c('span',{staticClass:"ui-switch__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ui-switch__track",attrs:{"aria-hidden":"true"}},[_c('span',{staticClass:"ui-switch__thumb"})])
}]

export { render, staticRenderFns }